import { library, dom, config } from '@fortawesome/fontawesome-svg-core';

import {
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleRight,
    faCartPlus,
    faCertificate,
    faChevronLeft,
    faChevronRight,
    faInfoCircle,
    faMinus,
    faPencilAlt,
    faPhone,
    faPlus,
    faSearch,
    faShoppingCart,
    faSpinner,
    faVideo,
    faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';

import {
    faAddressBook,
    faClock,
    faTrashAlt,
} from '@fortawesome/free-regular-svg-icons';

import {
    faInstagram,
    faTwitterSquare,
    faVk,
    faWhatsappSquare,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';

library.add(
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleRight,
    faCartPlus,
    faCertificate,
    faChevronLeft,
    faChevronRight,
    faInfoCircle,
    faMinus,
    faPencilAlt,
    faPhone,
    faPlus,
    faSearch,
    faShoppingCart,
    faVideo,
    faQuestionCircle,
    faSpinner,

    faAddressBook,
    faClock,
    faTrashAlt,

    faInstagram,
    faTwitterSquare,
    faVk,
    faWhatsappSquare,
    faYoutube,
);

config.autoAddCss = false;
dom.watch();
